// import Cookies from 'js-cookie';

const TokenKey = 'Admin-Token';
const UserKey = 'Admin-User';

export function getToken() {
  return sessionStorage.getItem(TokenKey);
  // return Cookies.get(TokenKey);
}

export function getDivision() {
  return sessionStorage.getItem('division');
  // return Cookies.get('division');
}

export function setDivision(val) {
  return sessionStorage.setItem('division', val);
  // return Cookies.set('division', val);
}

export function setCantonList(val) {
  // return Cookies.set('cantonList', val);
  return sessionStorage.setItem('cantonList', JSON.stringify(val));
}

export function getCantonList() {
  // return Cookies.get('cantonList');
  let cantonList = sessionStorage.getItem('cantonList');
  return cantonList ? cantonList: '';
}

export function setToken(token) {
  return sessionStorage.setItem(TokenKey, token);
  // return Cookies.set(TokenKey, token);
}

export function removeToken() {
  return sessionStorage.removeItem(TokenKey);
  // return Cookies.remove(TokenKey);
}

export function removeUser() {
  return sessionStorage.removeItem(UserKey);
  // return Cookies.remove(UserKey);
}

export function getUser() {
  return sessionStorage.getItem(UserKey);
  // return Cookies.get(UserKey);
}

export function setUser(User) {
  return sessionStorage.setItem(UserKey, User);
  // return Cookies.set(UserKey, User);
}

export function setSystem(val) {
  return sessionStorage.setItem('BisWebSiteName', val);
  // return Cookies.set('BisWebSiteName', val);
}
export function getSystem() {
  return sessionStorage.getItem('BisWebSiteName')?.value;
  // return Cookies.get('BisWebSiteName');
}